var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterfaceFavoriteHeartRewardSocialRatingMediaHeartItLikeFavoriteLove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5388 4.81414C14.8878 2.70514 18.5178 2.77514 20.7808 5.04214C23.0428 7.31014 23.1208 10.9221 21.0168 13.2781L12.5368 21.7701L4.05885 13.2781C1.95485 10.9221 2.03385 7.30414 4.29485 5.04214C6.55985 2.77814 10.1828 2.70214 12.5388 4.81414ZM19.3648 6.45514C17.8648 4.95314 15.4448 4.89214 13.8748 6.30214L12.5398 7.50014L11.2038 6.30314C9.62885 4.89114 7.21385 4.95314 5.70985 6.45714C4.21985 7.94714 4.14485 10.3321 5.51785 11.9081L12.5378 18.9391L19.5578 11.9091C20.9318 10.3321 20.8568 7.95014 19.3648 6.45514Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceFavoriteHeartRewardSocialRatingMediaHeartItLikeFavoriteLove);
export default __webpack_public_path__ + "static/media/interface-favorite-heart--reward-social-rating-media-heart-it-like-favorite-love.069841fb54f2650c2eb73aa661594594.svg";
export { ForwardRef as ReactComponent };